import { Stack } from '@awazevr/design-system.components.stack'
import { Text } from '@awazevr/design-system.components.text'

import {
  StyledGuestRatingValue,
  StyledStarsContainer,
} from './GuestRating.styles'

export type GuestRatingProps = {
  rating: number
  label?: string
  outOfLabel?: string
}

export const GuestRating = ({
  rating,
  label = 'Guest Rating',
  outOfLabel = 'out of 5',
}: GuestRatingProps): JSX.Element | null => {
  if (!rating || rating <= 0) return null

  return (
    <div>
      <Text sizes={100} type="mid" mb={4}>
        {label}
      </Text>

      <StyledStarsContainer
        role="img"
        aria-label={`${label}: ${rating} ${outOfLabel}`}
      >
        <Stack direction="row" spacing={4} align={'center'}>
          <svg
            width="20"
            viewBox="0 0 161 78"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M40.2 68.9C25.8 68 14.3 56.5 13.4 42H70.4H76.4V41.3C76.4 16.6 60.6 0 38.8 0C15.7 0 0 16.9 0 38.9C0 59.7 16.2 78 38.3 78C54.4 78 67.1 69.1 74 52.5H67.7C63.1 62.2 53.3 68.9 42 68.9C41.2 69 40.7 69 40.2 68.9Z"
              fill="#FFDD00"
            ></path>
            <path
              d="M120.098 68.9C134.498 68 145.998 56.5 146.898 42H89.8984H83.8984V41.3C83.8984 16.6 99.6984 0 121.498 0C144.598 0 160.298 16.9 160.298 38.9C160.298 59.7 144.098 78 121.998 78C105.898 78 93.1985 69.1 86.2985 52.5H92.6984C97.2984 62.2 107.098 68.9 118.398 68.9C118.898 69 119.498 69 120.098 68.9Z"
              fill="#FFDD00"
            ></path>
          </svg>
          <StyledGuestRatingValue aria-hidden="true">
            <strong>{rating}</strong>/5
          </StyledGuestRatingValue>
        </Stack>
      </StyledStarsContainer>
    </div>
  )
}
